import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import {
  Grid,
  TextField as Field,
  IconButton,
  Tooltip,
  Typography
} from '@mui/material';
import { withStyles } from 'tss-react/mui';
import { ChevronRight, InfoOutlined } from '@mui/icons-material';
import { colors } from '../../../Utilities/LenoxColors';

const styles = ({ spacing }) => ({
  margin: {
    margin: spacing(1)
  },
  textArea: {
    flexBasis: 200,
    width: '100%',
    color: `${colors.lenoxLight1}!important`,
    '& .MuiInputBase-root': {
      minHeight: '100px',
      alignItems: 'flex-start',
      paddingTop: spacing(1.5),
      paddingBottom: spacing(1.5)
    },
    '& .MuiInputBase-input': {
      resize: 'vertical',
      fontFamily: 'inherit'
    }
  },
  subLabel: {
    marginTop: '6px',
    fontSize: '12px'
  },
  submit: {
    display: 'inline-flex',
    alignSelf: 'flex-start',
    marginTop: spacing(2)
  },
  tooltip: {
    display: 'flex',
    alignItems: 'center',
    gap: 4
  }
});

const TextArea = ({
  value: propValue,
  name,
  label,
  onChange,
  classes,
  message,
  blur,
  tooltipMessage,
  id,
  rows = 4,
  maxRows = 10,
  minRows = 4,
  fullwidth = 'false',
  inputProps = {},
  error = false,
  placeholder = '',
  disabled,
  includeSubmit = false,
  fieldGrid = 10,
  buttonsGrid = 2,
  submitRender,
  subLabel
}) => {
  const [value, setValue] = useState(propValue);

  useEffect(() => {
    setValue(propValue);
  }, [propValue]);

  useEffect(() => {
    if (value !== propValue && !blur) {
      setValue(propValue);
    }
  }, [value, propValue, blur]);

  const handleChange = ({ target: { value: newValue } }) => {
    setValue(newValue);
    if (!blur) {
      onChange(name, newValue);
    }
  };

  const handleBlur = ({ target: { value: blurValue } }) => {
    if (blur) {
      onChange(name, blurValue);
    }
  };

  const renderField = () => {
    return (
      <Field
        label={
          tooltipMessage ? (
            <div className={classes.tooltip}>
              {label}
              <Tooltip title={tooltipMessage} placement="bottom">
                <InfoOutlined style={{ height: '.7em', width: '.7em' }} />
              </Tooltip>
            </div>
          ) : (
            label
          )
        }
        multiline
        rows={rows}
        maxRows={maxRows}
        minRows={minRows}
        fullwidth={fullwidth}
        inputProps={inputProps}
        error={error}
        id={id || label}
        className={classNames(classes.textArea)}
        variant="outlined"
        InputLabelProps={{ shrink: true, style: { pointerEvents: 'auto' } }}
        helperText={tooltipMessage ? '' : message || ''}
        placeholder={placeholder}
        value={value || ''}
        onChange={handleChange}
        disabled={disabled}
        onBlur={handleBlur}
      />
    );
  };

  const renderSubmitButton = () => (
    <IconButton className={classes.submit} size="large">
      <ChevronRight />
    </IconButton>
  );

  return (
    <Grid key={name} container justifyContent="center" alignItems="flex-start">
      <Grid item xs={12} className={classNames(classes.margin)}>
        <Grid container justifyContent="center" alignItems="flex-start">
          <Grid item xs={includeSubmit ? fieldGrid : 12}>
            {renderField()}
            {subLabel && (
              <Typography className={classes.subLabel}>{subLabel}</Typography>
            )}
          </Grid>
          {includeSubmit && (
            <Grid item xs={buttonsGrid}>
              {submitRender ? submitRender() : renderSubmitButton()}
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default withStyles(TextArea, styles);
